// extracted by mini-css-extract-plugin
module.exports = {"root":"mIndex_root__sBdel","icon":"mIndex_icon__Qti6Z","title":"mIndex_title__wuy_P","desc":"mIndex_desc__yYw41","button":"mIndex_button__EPQ61"};